module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./QuestionDetailView.js"));
	}, "QuestionDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QuestionDetailView!./src/pages/Shop/Product/ProductDetail/QuestionDetail/QuestionDetailView.js
// module id = 1352
// module chunks = 418